module.exports = __webpack_public_path__ + "media/images/slide-15-c206c9185d14a8e4cee49e25fa89f782.jpg";